import React from "react";
import { connect } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import Axios from "axios-https-proxy-fix";
import Translated from "../../components/Translated/Translated";

function DialogNotes(props) {
	const [open, setOpen] = React.useState(false);
	const [text, setText] = React.useState("");
	const [loading, setLoading] = React.useState(false);
	const [response, setResponse] = React.useState({});

	async function handleClose(e) {
		e.stopPropagation();
		setOpen(false);
	}

	async function handleClickOpen(e) {
		console.log("here is the vlaue for the props ", props);
		e.stopPropagation();
		setResponse({});
		setText(props.notes);
		setOpen(true);
	}

	async function submit() {
		setResponse({});
		setLoading(true);
		let requestURL = props.APIUrl + "/projects/update-notes";
		let APIResponse = await Axios.post(requestURL, {
			project_id: props.projectId,
			notes: text,
			language: props.selected_language
		});
		setResponse(APIResponse.data);
		props.re_render_project_search_results(); // Re render the project search results so when they reopen this dialog the updated note appears.
		setLoading(false);
	}

	function formBody() {
		return (
			<div class="quote-dialog-body">
				<div class="fquote-dialog-info">
					<textarea
						class="project-notes-textarea"
						disabled={loading}
						onChange={e => setText(e.target.value)}
						value={text}
					></textarea>
				</div>
			</div>
		);
	}

	function responseBody() {
		let class_names = "quote-dialog-body quote-dialog-";
		class_names += response.hasOwnProperty("error") ? "error" : "success";

		return (
			<div className={class_names}>
				<div>{response.hasOwnProperty("error") ? response.error : response.success}</div>
			</div>
		);
	}

	let hasResponse = Object.keys(response).length;

	return (
		<td class="dialog-status-wrapper project-notes-td" onClick={handleClickOpen}>
			<div style={{ whiteSpace: "nowrap" }} class="dialog-status">
				{props.notes.length === 0 
					? <Translated section="Misc" label="notes_add_label" />
					: <Translated section="Misc" label="notes_view_label" />
				}{" "}
				<i class="fas fa-sticky-note"></i>
			</div>
			<Dialog open={open} onClose={handleClose} onClick={e => e.stopPropagation()}>
				<div class="quote-dialog">
					<div class="quote-dialog-title"><Translated section="Misc" label="project_notes_dialog_title" /></div>
					{formBody()}
					{hasResponse ? responseBody() : null}
					<div
						className={"quote-dialog-footer" + (loading ? " diable-dialog-footer" : "")}
					>
						<button class="quote-dialog-button" onClick={loading ? null : handleClose}>
							<Translated section="Misc" label="close_btn" />
						</button>
						<button class="quote-dialog-button" onClick={loading ? null : submit}>
							<Translated section="Misc" label="save_label" />
						</button>
					</div>
				</div>
			</Dialog>
		</td>
	);
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl,
	selected_language: state.selected_language
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DialogNotes);
